/**
 * This is the dto for the customer
 *
 * Note: properties starting with a '_' are removed before sending
 *
 * @module app.model
 * @license Copyright 2013 (c) RISE Ges.m.b.H.
 *  ____   ___  ____   _____
 * |  _ \  | | / ___| | ____|
 * | |_) | | | \___ \ |  _|
 * |  _ <  | |  ___) || |___
 * |_| \_\ |_| |____/ |_____|
 *
 */
(function(app) {
    "use strict";

    app.dto.CustomerDto = function CustomerDetailsDto(json) {
        var obj = (typeof json === 'string') ? JSON.parse(json) : json;

        if (!obj) {
            obj = {};
        }

        this.id = obj.id ? parseInt(obj.id) : null;
        this.name = obj.name ? obj.name : null;
        this.email = obj.email ? obj.email : null;
        this.active = obj.active ? obj.active : null;
    };

    app.dto.CustomerDetailsDto = function CustomerDetailsDto(json) {
        var obj = (typeof json === 'string') ? JSON.parse(json) : json;

        if (!obj) {
            obj = {};
        }

        this.customer = obj.customer != null
            ? new app.model.Customer(obj.customer)
            : null;

        // map event types
        this.assigned_event_types = obj.assigned_event_types
            ? _.map(obj.assigned_event_types, function (j) { return new app.model.EventType(j); })
            : [];

        // map business_documents
        this.assigned_business_documents = obj.assigned_business_documents
            ? _.map(obj.assigned_business_documents, function (j) { return new app.model.BusinessDocument(j); })
            : [];

        // map tours
        this.assigned_tours = obj.assigned_tours
            ? _.map(obj.assigned_tours, function (j) { return new app.model.Tour(j); })
            : [];
    };

    app.dto.CustomerAssignmentsDto = function CustomerAssignmentsDto(json) {
        var obj = (typeof json === 'string') ? JSON.parse(json) : json;

        if (!obj) {
            obj = {};
        }

        // map event types
        this.assigned_event_types = obj.assigned_event_types
            ? _.map(obj.assigned_event_types, function (j) { return new app.dto.EventTypeWithAssignmentInfoDto(j); })
            : [];

        // map business_documents
        this.assigned_business_documents = obj.assigned_business_documents
            ? _.map(obj.assigned_business_documents, function (j) { return new app.dto.BusinessDocumentWithAssignmentInfoDto(j); })
            : [];
    };

}(window.app));
